import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Typography } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TimePeriodTabs } from 'pages/settings/ui/BillingPlan/ui/TimePeriodTabs'
import { type IOpportunityModalProps } from 'pages/settings/pages/billing/pages/overview/ui/OpportunityModal/store/types'
import { OpportunityModalStore } from 'pages/settings/pages/billing/pages/overview/ui/OpportunityModal/store/opportunityModalStore'
import { CurrentPlanCard } from './CurrentPlanCard'
import { RecommendedPlanCard } from './RecommendedPlanCard'
import { CustomPlanCard } from './CustomPlanCard'
import styles from './styles.module.scss'

export const OpportunityModal = observer(({ onUpgradeSuggestedPlan }: IOpportunityModalProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new OpportunityModalStore(entities))

  return (
    <div className={styles.headerContent}>
      <Typography ariaLabel='opportunity_modal_title' variant='heading-lg'>
        Same Usage. Lower Cost. No Surprises.
      </Typography>
      <Typography
        ariaLabel='opportunity_modal_description'
        variant='body-lg-regular'
        color={'var(--content-primary-secondary)'}
        className={styles.description}
      >
        You used {numberFormat({ value: store.totalCreditsUsed })} credits {store.periodText}. This
        plan gives you the same total usage and features for less money.
      </Typography>

      {store.showTimePeriodTabs && (
        <TimePeriodTabs
          period={store.period}
          className={styles.timePeriodTabs}
          handleSetPeriod={store.handleSetPeriod}
        />
      )}

      <div className={styles.plansContainer}>
        <CurrentPlanCard
          data={store.currentPlanData}
          subscriptionPeriod={store.subscriptionSuggestion?.current_plan_period}
          showAdditionalPriceInfo={store.showAdditionalPriceInfo}
          convertedCurrentPlanCredits={store.convertedCurrentPlanCredits}
          totalCreditsUsed={store.totalCreditsUsed}
          onKeepCurrentPlan={store.handleKeepCurrentPlan}
          showCustomPlanUI={store.showCustomPlanUI}
          hasTimePeriodTabs={store.showTimePeriodTabs}
        />

        {store.showCustomPlanUI ? (
          <CustomPlanCard
            onChatWithSales={store.chatWithSalesFromModalHandler}
            onBookMeeting={store.onBookMeetingViaHubSpotHandler}
            onShowGetCallModal={store.showGetCallModal}
          />
        ) : (
          store.recommendedPlanData && (
            <RecommendedPlanCard
              data={store.recommendedPlanData}
              planBasePrice={store.planBasePrice}
              showAdditionalPriceInfo={store.showAdditionalPriceInfo}
              showGreyBorder={store.showGreyBorder}
              suggestedMonthlyTotalPriceYearly={store.suggestedMonthlyTotalPriceYearly}
              suggestedYearlyPlanTotalPrice={store.suggestedYearlyPlanTotalPrice}
              onUpgrade={() => {
                store.sendOpportunityEvent('Continue with Upgrade')
                onUpgradeSuggestedPlan(store.period)
              }}
              onSeeOtherPlans={store.handleSeeOtherPlans}
              hasTimePeriodTabs={store.showTimePeriodTabs}
            />
          )
        )}
      </div>
    </div>
  )
})
